import AssinaturaVitalícia from '../../../../assets/icons/AssinaturaVitalicia.png'
import AssinaturaVitalíciaPremium from '../../../../assets/icons/AssinaturaVitalíciaPremium.png'
import AssinaturaEssencial from '../../../../assets/icons/AssinaturaEssencial.png'
import AssinaturaOuro from '../../../../assets/icons/AssinaturaOuro.png'
import AssinaturaDegustação from '../../../../assets/icons/AssinaturaDegustacao.png'
import LogoDirecao from '../../../../assets/logos/logoOnly.png'
import history from '../../../../services/history'

import { Container, SubscriptionContainer } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'

const SubscriptionsListComponent = () => {
  const { subscriptions } = useSelector((state: RootState) => state.subscription)

  const subscriptionImages = {
    AssinaturaVitalícia,
    AssinaturaVitalíciaPremium,
    AssinaturaEssencial,
    AssinaturaOuro,
    AssinaturaDegustação,
  }

  return (
    <>
      <Container>
        <h2>Minhas assinaturas</h2>
        <div className="cards">
          {subscriptions.length > 0 ? (
            subscriptions.map((item, idx) => {
              return (
                <SubscriptionContainer
                  key={idx}
                  onClick={() => history.push(`/subscription/${item._id}`)}
                  data-quantity-cards={subscriptions.length}
                >
                  <img
                    src={subscriptionImages[item.name.replaceAll(' ', '')] || LogoDirecao}
                    alt={item.name}
                  />
                  <h3>{item.name}</h3>
                </SubscriptionContainer>
              )
            })
          ) : (
            <p>
              Você não possui assinatura adquirida. Acesse nosso{' '}
              <a
                href="https://assinaturas.direcaoconcursos.com.br/"
                target="_blank"
                rel="noreferrer"
              >
                site
              </a>{' '}
              e confira nossas assinaturas.
            </p>
          )}
        </div>
      </Container>
    </>
  )
}

export default SubscriptionsListComponent
